<template>
    <v-card color="bgtopology" elevation="0">
        
        <v-card-title class="pa-0">
            <v-row justify="space-between" class="ma-0">
                <div class="ml-4">
                    <span class="subtitleDashboard"> {{ t('labels.ociTitle') }} <span class="subtitleDashboard" style="font-size: 24px !important;" >{{ t('labels.oci') }}</span> </span>
                </div>
                <v-menu  
                v-model="menu"
                class="menuGauge"
                :close-on-content-click="false"
                location="end">
                    <template v-slot:activator="{ props }">
                        <v-btn color="colorText" variant="text" icon="mdi-cog-outline" size="small" v-bind="props"></v-btn>
                    </template>

                    <!-- <v-sheet width="600" max-height="550" color="bgtopology" class="datepickerContainer"> -->
                    <v-sheet width="800" height="110" color="bgtopology">
                        <v-row class="ma-3" justify=space-between>
                            <span class="subtitleGAUGE">{{ t('labels.confIEO') }}</span>
                            <v-btn icon="mdi-close" density="compact" @click="menu = false" variant="text"></v-btn>    
                        </v-row>
                        <v-row class="ma-0" justify="space-between">
                            <v-sheet class="centerCard" color="transparent" width="60"> 0 % </v-sheet>
                            <v-sheet class='centerCard gaugeCardFilter cardBorderColorRed' color="transparent" width="140"> {{ t('labels.alarm') }} </v-sheet>
                            <v-sheet color="transparent" width="90">
                                <v-text-field
                                v-model="minValue"
                                suffix="%"
                                width="90"
                                variant="outlined"
                                density="compact"
                                type="number"
                                hide-details
                                hide-spin-buttons
                                :rules="fieldRules"
                                >
                                    <template v-slot:append>
                                        <v-col class="pa-0">
                                            <v-sheet height='20' color="transparent">
                                                <v-icon size="small" :disabled="minValue >= maxValue - 1" @click="upValue('minValue')"> mdi-menu-up </v-icon>
                                            </v-sheet>
                                            <v-sheet color="transparent" height='20'>
                                                <v-icon size="small" :disabled="minValue <= 0 " @click="downValue('minValue')"> mdi-menu-down </v-icon>                                
                                            </v-sheet>
                                        </v-col>
                                    </template>
                                </v-text-field>
                            </v-sheet>
                            <v-sheet class='centerCard gaugeCardFilter cardBorderColorYellow' color="transparent" width="140"> {{ t('labels.alert') }} </v-sheet>

                            
                            <v-sheet color="transparent" width="90">
                                <v-text-field
                                v-model="maxValue"
                                suffix="%"
                                width="90"
                                variant="outlined"
                                density="compact"
                                type="number"
                                hide-details
                                hide-spin-buttons
                                :rules="fieldRules"
                                >
                                    <template v-slot:append>
                                        <v-col class="pa-0">
                                            <v-sheet height='20' color="transparent">
                                                <v-icon size="small" :disabled="maxValue >= 99" @click="upValue('maxValue')"> mdi-menu-up </v-icon>
                                            </v-sheet>
                                            <v-sheet color="transparent" height='20'>
                                                <v-icon size="small" :disabled="maxValue - 1 <= minValue && minValue >= 0 " @click="downValue('maxValue')"> mdi-menu-down </v-icon>                                
                                            </v-sheet>
                                        </v-col>
                                    </template>
                                </v-text-field>
                            </v-sheet>
                            
                            <v-sheet class='centerCard gaugeCardFilter cardBorderColorGreen' color="transparent" width="140"> {{ t('labels.ok') }} </v-sheet>
                            
                            <v-sheet  class="centerCard" color="transparent" width="60"> 100 % </v-sheet>
                        </v-row>
                    </v-sheet>                    
                </v-menu>
            </v-row>

        </v-card-title>
        
        <v-card-text class="pa-0" style="text-align: -webkit-center;">
            <v-sheet class="gaugeClass" color="transparent" v-if="showGraph" :width="smAndDown ? '395' :'100%'" height="400" >
                <HexagonMinComponent 
                class="HexagonPos Hex1"
                :title="finalItemsNow.item.ok.toFixed(2)"
                :color="'red'"
                :subtitle="t('labels.online')"                
                :minValue="minValue/100"
                :maxValue="maxValue/100"
                :size-hexa="160"
                :size-title="55"
                :size-sub-ti="16"
                />
                <HexagonMinComponent 
                class="HexagonPos Hex2"
                :title="finalItemsDay.item.ok.toFixed(2)"
                :color="''"
                :subtitle="t('labels.day')"
                :minValue="minValue/100"
                :maxValue="maxValue/100"
                :size-hexa="sizeHexa"
                :size-title="sizeTitl"
                :size-sub-ti="sizeSubt"
                />
                <HexagonMinComponent 
                class="HexagonPos Hex3"
                :title="finalItems2Seman.item.ok.toFixed(2)"
                :color="''"
                :subtitle="'2 ' + t('labels.week') + 's'"
                :minValue="minValue/100"
                :maxValue="maxValue/100"
                :size-hexa="sizeHexa"
                :size-title="sizeTitl"
                :size-sub-ti="sizeSubt"
                /> 
                <HexagonMinComponent 
                class="HexagonPos Hex4"
                :title="finalItemsSeman.item.ok.toFixed(2)"
                :color="''"
                :subtitle="t('labels.week')"
                :minValue="minValue/100"
                :maxValue="maxValue/100"
                :size-hexa="sizeHexa"
                :size-title="sizeTitl"
                :size-sub-ti="sizeSubt"
                />

           </v-sheet>
           <v-row class="pt-5" v-if="!showGraph && !showError" justify="center">
                <Prog_circular/>
           </v-row>
        </v-card-text>
    </v-card>
 </template>
 
<script setup lang="ts">
import { ref, Ref, onMounted, computed, ComputedRef, watch } from 'vue';
import { format } from "@formkit/tempo";

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { STRING_GENERAL } from '@/constants/labels';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { smAndDown } = useDisplay();

/********************************
 ********** COMPONENTS **********
 *******************************/
import HexagonMinComponent from '@/components/principalPage/hexagonMinComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { ItemStatus, ItemStatusArray } from '@/interfaces/SmartLink/Equips';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getFinDate, getTimeZone } from '@/functions/project';
import { OPERABILITY } from '@/interfaces/SmartLink/Equipos';

const props = defineProps({
    recharge    : { type: Boolean, required: true },
    arrayItems  : { type: Array<OPERABILITY>, required: true },
    valorCard   : { type: String, default: 'distri'}
})


/***************************************
************ MENU DESPEGABLE *********** 
***************************************/

const menu      = ref(false);
const minValue  = ref(60);
const maxValue  = ref(90);
const sizeHexa  = ref(120);
const sizeTitl  = ref(30);
const sizeSubt  = ref(13);

const fieldRules = computed ( () =>  [(v:number) => !!v || 'Requerido',],)

watch (minValue, (valor:number) => {
    const limitValue =  ref( maxValue.value - 1 );
    if(valor >= limitValue.value && valor > 0) minValue.value = limitValue.value ;
    if(valor < 0 ) { minValue.value = 1 }
} )

watch (maxValue, (valor:number) => {
    const limitValue = ref( minValue.value + 1 );
    if(valor <= limitValue.value && valor < 100 && valor > 0) minValue.value = limitValue.value ;
    if(valor > 100 ) maxValue.value = 99;
} )

const upValue = (typeValue:string) => {
    if(typeValue === 'minValue') minValue.value ++;
    if(typeValue === 'maxValue') maxValue.value ++;
}
const downValue = (typeValue:string) => {
    if(typeValue === 'minValue') minValue.value --;
    if(typeValue === 'maxValue') maxValue.value --;
}


/***************************************
************** CAPTURA IEO ************* 
***************************************/
const timezone          = getTimeZone();
const isRecharge        = computed(()=> props.recharge)
const valorCard         = computed(()=> props.valorCard)
const showError         = ref(false);
const showGraph         = ref(false);
const totalItemsOper:ComputedRef<OPERABILITY[]> = computed(() => props.arrayItems);
const itemsFiltered:Ref<OPERABILITY[]>   = ref([]);

/**
 * IEO del día
 */
const finalItemsDay:Ref<ItemStatus>      = ref({ item : {ok: 0,alert: 0,alarm: 0,down: 0 }});

/**
 * IEO de los últimos 15 minutos (último registro)
 */
const finalItemsNow:Ref<ItemStatus>      = ref({ item : {ok: 0,alert: 0,alarm: 0,down: 0 }});

/**
 * IEO de la semana
 */
const finalItemsSeman:Ref<ItemStatus>    = ref({ item : {ok: 0,alert: 0,alarm: 0,down: 0 }});

/**
 * IEO del mes
 */
const finalItems2Seman:Ref<ItemStatus>    = ref({ item : {ok: 0,alert: 0,alarm: 0,down: 0 }});


/**
 * Obtienes el tiempo en el formato correspondiente y tambien dependiendo de la zona horaria
 * @param time 
 * @param timezone 
 */
 const getTime = (time:Date, timezone:string) => {
    const finalTime =  format({
        date: time,
        format: "YYYY-MM-DD HH:mm:ss",
        tz: timezone,
    })
    return finalTime.toString()
}


/**
 * Captura las fehas iniciales y finales, dependiendo de la zona horaria
 * para poder ver datos correctos desde cualquier parte del mundo
 * desde el navegador
 * @param minutes 
 * @param petition (SOLO para discriminar al final y almacenar en la variable correspondiente)
 */
const getIEOByDates = (minutes:number, petition: number) => {
    showError.value     = false;
    showGraph.value     = false;
    const nowTime       = getFinDate();
    const dateFin       = getFinDate();

    
    const minusMinute   = nowTime.getTime() - (1000 * 60 * minutes);
    const iniDate       = new Date(minusMinute);
    
    getObjectByDates(getTime(iniDate, timezone),getTime(dateFin, timezone),petition);
}


/**
 * Teniendo los valores de la fecha iniciante (minutos atrás) y la fecha final (fecha actual),
 * capturamos los valores que se encuentran dentro de ese rango de fechas
 * 
 * @param dateIni 
 * @param dateFin 
 * @param petition (SOLO para discriminar al final y almacenar en la variable correspondiente)
 */
const getObjectByDates = (dateIni:string, dateFin:string, petition:number) => {
    itemsFiltered.value = [];

    // Si petition es igual a 4 (ultimos 15 minutos), se obtendra el ultimo valor registrado
    // Esto con el fin de evitar valores 0 dentro del 'IEO en línea'
    // if(petition == 4 && ipAPIS !== 'http://192.168.2.223:4159/api/') { //CAMBIAR LAS IPAPIS
    if(petition == 4) {
        itemsFiltered.value.push(totalItemsOper.value[0])
    } 
    // Para todos los demás casos, se capturan los datos dentro del rango de fechas establecidas
    else{
        totalItemsOper.value.forEach((item:OPERABILITY) => {
            if(item.fecha && new Date(item.fecha).getTime() <= new Date(dateFin).getTime() && new Date(item.fecha).getTime() >= new Date(dateIni).getTime()){
                itemsFiltered.value.push(item)
            }
        })
    }
    getFinalItemsToShow(itemsFiltered.value, petition)
}

/**
 * Captura el promedio de los valores de ok, alertas, alarmas y caidos, dependiendo de los tiempos establecidos
 * anteriormente y los almacena en las variables, dependiendo del tipo de petición
 * @param allData (datos filtrados por fecha)
 * @param typePetition (para almacenar en variables distintas)
 */
const getFinalItemsToShow = (allData:Array<OPERABILITY>,typePetition:number) => {
    
    //Creo los array de números
    let OBJOperability:ItemStatusArray = {
        item: {
            ok      : [],
            alert   : [],
            alarm   : [],
            down    : [],
        },
    }

    // Si hay información obtenida, se realizará la lógica
    if(allData.length >= 1){
        showError.value = false;
        allData.forEach((elem:OPERABILITY)=>{
            let cantTotal      = (elem.ok??0) + ( elem.alarm??0) + (elem.alert??0) + (elem.down??0);
            let ok             = (elem.ok??0)/cantTotal;
            let alerta         = (elem.alarm??0)/cantTotal;
            let alarma         = (elem.alert??0)/cantTotal;
            let down           = (elem.down??0)/cantTotal;

            // para evitar los NaN en el IEO, porque son equipos que no registran ningun estado en el tiempo.
            if(cantTotal === 0) {
                ok      = 0;
                alerta  = 0;
                alarma  = 0;
                down    = 0;
            }

            // hago el push del IEO de cada item en cada objeto correspondiente, 
            // para el caso del OK, coloco un default de 0, por si presentan valores NaN (por comprobar)
            OBJOperability.item.ok.push(ok??0)
            OBJOperability.item.alarm.push(alerta)
            OBJOperability.item.alert.push(alarma)
            OBJOperability.item.down.push(down)  
        })


        // Sumamos los elementos de cada Array
        // Sacamos la cantidad de elementos que tiene el array
        // Promediamos
        let sumOkitem = OBJOperability.item.ok.reduce((a:number, b:number) => a + b);
        let totOkitem = OBJOperability.item.ok.length;
        let proOkitem = sumOkitem/totOkitem;

        let sumAlertitem = OBJOperability.item.alert.reduce((a:number, b:number) => a + b);
        let totAlertitem = OBJOperability.item.alert.length;
        let proAlertitem = sumAlertitem/totAlertitem;

        let sumAlarmitem = OBJOperability.item.alarm.reduce((a:number, b:number) => a + b);
        let totAlarmitem = OBJOperability.item.alarm.length;
        let proAlarmitem = sumAlarmitem/totAlarmitem;

        let sumDownitem = OBJOperability.item.down.reduce((a:number, b:number) => a + b);
        let totDownitem = OBJOperability.item.down.length;
        let proDownitem = sumDownitem/totDownitem;

        // reemplazamos los valores del array final por los valores obtenidos (promedio obtenido)
        let finalArray = {
            item : {
                ok      : parseFloat(proOkitem.toFixed(2)),
                alert   : proAlertitem,
                alarm   : proAlarmitem,
                down    : proDownitem,
            },
        }

        //Dependiendo del tipo de pedido, lo guardo en su variable correspondiente
        typePetition === 0 ? finalItemsDay.value    = finalArray : null; //array del dia
        typePetition === 2 ? finalItemsSeman.value  = finalArray : null; //array de la semana
        typePetition === 3 ? finalItems2Seman.value  = finalArray : null; //array del mes
        typePetition === 4 ? finalItemsNow.value    = finalArray : null; //array en linea
    }
    showGraph.value = true;
}

watch(isRecharge, (rech:boolean) =>{
    if(rech) {
        if(props.arrayItems.length > 0){
            getIEOByDates(1440,0);  //1440 minutos (1 dia)
            getIEOByDates(10080,2); //10080 minutos (1 semana)
            getIEOByDates(20160,3); //20160 minutos (2 semanas)
            getIEOByDates(15,4);    //15 minutos (ultimo registro)    
        }
    }
})


/**
 * Al final de cada ciclo y dependiendo del valor que viene del props
 * Almacena el valor del IEO de los ultimos 15 minutos de cada Familia
 * en la STORE y este se usara para mostrarlo al lado del Mapa
 * encima de los mensajes de alarma y alertas
 */
watch(showGraph,(isShow:boolean) => {
    if(isShow){
        if(valorCard.value === STRING_GENERAL.distri) store.commit('setIEODistri',finalItemsNow.value.item.ok.toFixed(2)??'0')
        if(valorCard.value === STRING_GENERAL.access) store.commit('setIEOAcceso',finalItemsNow.value.item.ok.toFixed(2)??'0')
        if(valorCard.value === STRING_GENERAL.client) store.commit('setIEOClient',finalItemsNow.value.item.ok.toFixed(2)??'0')
    }
})

onMounted(async ()=>{
    //Si trae algún array con minimo un valor, hará toda la lógica que encuentra
    if(props.arrayItems.length > 0){
        getIEOByDates(1440,0); //1440 minutos (1 dia)
        getIEOByDates(10080,2); //10080 minutos (1 semana)
        getIEOByDates(20160,3); //20160 minutos (2 semanas)
        getIEOByDates(15,4); //15 minutos (ultimo registro) 
    }
    //Si no encuentra, mostrará los valores 0
    //Entra al Watch
    else{
        showGraph.value = true;
    }
})

</script>
<style>
.boderCard{
    border: 0.1px solid rgba(0,0,0,.3);
    border-radius: 10px;
    margin: 0 0.3px;
    align-self: center;
}

.subtitleTUM, .subtitleTUM2{
    padding-top: 108px !important;
    padding-bottom: 20px !important;
}
.subtitleTUM2{
    padding-top: 180px !important;
}

.TUMtitle{
    position: absolute;
    z-index: 3;
    top: 90%;
    left: 17%;
    /* transform: translate(-60%, -50%); */
    cursor: pointer;
    font-family: 'Poppins',sans-serif;
    font-weight: 400;
    font-size: 20px;
}

.menuGauge .v-input__append{
    margin: 0 !important;
}
.centerCard{
    align-content: center; 
    text-align: center;
}

.gaugeCardFilter {
    border-style: none none solid none;
    border-width: 8px;
    border-start-start-radius: 5px;
    /* border: 5px solid green; */
}
.cardBorderColorGreen{
    border-color: #427739;
}
.cardBorderColorRed{
    border-color: #E04637;
}
.cardBorderColorYellow{
    border-color: #F9DC4B;
}
.subtitleGAUGE{
    font-size: 20px;
    font-weight: bold;
}
.gaugeClass {
    position:relative;
}

.gaugeClass .HexagonPos{
    position: absolute;
    z-index: 2;
}
.Hex1{
    left: 6%;
    top: 30%;
}
.Hex2{
    left: 42%;
    top: 19.5%;
}
.Hex3{
    left: 42%;
    top: 50%;
}
.Hex4{
    left: 69%;
    top: 35%;
}
</style>